import { IconButton } from '@sunwebgroup/uds-ui/icon-button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore'
import { useGroupResponsibleUseCases } from '@/scopes/account/group-responsible/pages/dependencies'
import { getParticipantsEditingData } from '../selectors'
import { FloatingToolbar } from './FloatingToolbar'

export function Toolbar() {
  const intl = useIntl()
  const { selectedCount, totalCount } = useGroupResponsibleStore(getParticipantsEditingData)
  const useCases = useGroupResponsibleUseCases()
  const toggleIsEditingParticipants = useGroupResponsibleStore(state => state.toggleIsEditingParticipants)

  const handleEditClick = async () => {
    toggleIsEditingParticipants(true)
    await useCases.loadBusPickUpPoints()
  }

  if (selectedCount === 0) {
    return null
  }

  return (
    <FloatingToolbar ariaLabel={intl.formatMessage({ id: 'groups_responsible_bus_selection_toolbar_aria_label' })}>
      <FloatingToolbar.Item>
        <Typography variant="body-s-bold-tight">
          {intl.formatMessage(
            {
              id: 'groups_responsible_selected_count',
            },
            {
              selected: selectedCount,
              total: totalCount,
            },
          )}
        </Typography>
      </FloatingToolbar.Item>
      <FloatingToolbar.Divider />
      <FloatingToolbar.Item>
        <IconButton
          glyph="Pencil"
          title={intl.formatMessage({ id: 'common_edit' })}
          size="S"
          variant="transparent-neutral"
          onClick={handleEditClick}
        />
      </FloatingToolbar.Item>
    </FloatingToolbar>
  )
}
